import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type CraneIconProps = Omit<BaseIconProps, 'children'>;

export const CraneIcon = ({ ...props }: CraneIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" fill="none" hasLegacyStrokeStyles={true} {...props}>
    <g clipPath="url(#clip0_1624_8718)" fill="none">
      <path d="M5 23V1H9V23" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M2 23H12" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M9 4L23 5V8H9" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M5 8H1V5L5 4" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M20 11V16" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M23 16H17V20H23V16Z" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
    </g>
    <defs>
      <clipPath id="clip0_1624_8718">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </BaseIcon>
);
